import './style';
import App from './components/app';
import { Provider } from 'redux-zero/preact';
import store from './store';

export default () => (
	<Provider store={store}>
		<App />
	</Provider>
);



// WEBPACK FOOTER //
// ./index.js